import { useTranslation } from "react-i18next";
import type {
  EligibleShipment,
  PickupPreview,
} from "@/api/use-schedule-pickup";
import { SheetSection } from "./sheet-primitives";

export function PickupDeliveryConsequences({
  consequences,
  shipments,
  timeZone,
}: {
  consequences: PickupPreview["deliveryConsequences"];
  shipments: readonly Pick<EligibleShipment, "id" | "shipmentNumber">[];
  timeZone: string | null;
}) {
  const { t, i18n } = useTranslation("app");
  const locale = i18n.resolvedLanguage ?? i18n.language;
  const changes =
    consequences?.filter(
      (change) => change.previousEstimatedDelivery !== change.estimatedDelivery
    ) ?? [];
  if (!changes.length) return null;
  const dateLabel = (value: string | null) =>
    value
      ? new Date(value).toLocaleDateString(locale, {
          timeZone: timeZone ?? "UTC",
        })
      : t("pickup.where.deliveryUnknown");
  return (
    <SheetSection title={t("pickup.where.deliveryTitle")}>
      <div className="space-y-2 text-xs">
        {changes.map((change) => (
          <p key={change.shipmentId}>
            SHP-
            {
              shipments.find((shipment) => shipment.id === change.shipmentId)
                ?.shipmentNumber
            }
            :{" "}
            {t("pickup.where.deliveryChange", {
              previous: dateLabel(change.previousEstimatedDelivery),
              current: dateLabel(change.estimatedDelivery),
            })}
          </p>
        ))}
      </div>
    </SheetSection>
  );
}
